<div
  class="dashboard-client-shell"
  [class.dashboard-client-shell--with-tabs]="showBottomTabs()"
  [class.dashboard-client-shell--selection-dock]="bottomTabsReplaced()"
  [class.dashboard-client-shell--mobile-app]="isMobileApp"
>
  @if (showWebHeader) {
    <header class="dashboard-client-shell__header">
      <div class="dashboard-client-shell__content-inner">
        <div class="dashboard-client-shell__header-start">
          <a
            class="dashboard-client-shell__logo-link"
            [routerLink]="navLink('')"
            [attr.aria-label]="'CLIENT.CABINET.ARIA.HOME' | translate"
          >
            <img
              class="dashboard-client-shell__logo"
              src="/icons/logos/full-logo-green-black.svg"
              alt=""
              aria-hidden="true"
              width="140"
              height="28"
            />
          </a>
        </div>

        <div class="dashboard-client-shell__header-end">
          <a class="dashboard-client-shell__return-link" routerLink="/">
            {{ 'CLIENT.CABINET.RETURN_TO_SITE' | translate }}
            <span
              class="dashboard-client-shell__return-link-icon"
              aria-hidden="true"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 12H19M14 7L19 12L14 17"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </a>
        </div>
      </div>
    </header>
  }

  <main class="dashboard-client-shell__content">
    <router-outlet />
  </main>

  @if (showBottomTabs()) {
    <nav
      class="dashboard-client-shell__tabs"
      [attr.aria-label]="'CLIENT.CABINET.ARIA.BOTTOM_TABS' | translate"
    >
      <div class="dashboard-client-shell__content-inner">
        <div class="dashboard-client-shell__tabs-dock">
          @for (item of bottomTabs; track item.route) {
            <a
              class="dashboard-client-shell__tab"
              [class.dashboard-client-shell__tab--active]="
                isNavActive(item.route, item.exact)
              "
              [routerLink]="navLink(item.route)"
              [attr.aria-current]="
                isNavActive(item.route, item.exact) ? 'page' : null
              "
            >
              <img
                class="dashboard-client-shell__tab-icon"
                [src]="item.icon"
                alt=""
                aria-hidden="true"
                width="16"
                height="16"
              />
              <span class="dashboard-client-shell__tab-label">{{
                item.labelKey | translate
              }}</span>
            </a>
          }
        </div>
      </div>
    </nav>
  }
</div>
